// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.discovery-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background:
    radial-gradient(circle at top, rgba(239, 68, 68, 0.12), transparent 32%),
    rgba(0, 0, 0, 0.88);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  animation: discovery-overlay-in 0.28s ease;
}

.discovery-modal {
  --cat-color: #ef4444;
  --cat-color-rgb: 239, 68, 68;
  position: relative;
  width: min(100%, 420px);
  padding: 28px 28px 24px;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background:
    linear-gradient(180deg, rgba(24, 24, 28, 0.98) 0%, rgba(12, 12, 14, 0.98) 100%);
  box-shadow:
    0 28px 90px rgba(0, 0, 0, 0.62),
    0 0 0 1px rgba(255, 255, 255, 0.03) inset;
  animation: discovery-modal-in 0.35s cubic-bezier(0.16, 1, 0.3, 1);
}

.discovery-modal::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 1px;
  background: linear-gradient(180deg, rgba(var(--cat-color-rgb), 0.5), rgba(255, 255, 255, 0.02));
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  pointer-events: none;
}

.discovery-modal--combat {
  --cat-color: #ef4444;
  --cat-color-rgb: 239, 68, 68;
}

.discovery-modal--tool {
  --cat-color: #2dd4bf;
  --cat-color-rgb: 45, 212, 191;
}

.discovery-modal--progression {
  --cat-color: #f59e0b;
  --cat-color-rgb: 245, 158, 11;
}

.discovery-modal--map {
  --cat-color: #ef4444;
  --cat-color-rgb: 239, 68, 68;
}

.discovery-modal--discovery {
  --cat-color: #818cf8;
  --cat-color-rgb: 129, 140, 248;
}

.discovery-topline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
}

.discovery-badge {
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 999px;
  border: 1px solid rgba(var(--cat-color-rgb), 0.22);
  background: rgba(var(--cat-color-rgb), 0.08);
  color: var(--cat-color);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.discovery-phase {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.34);
}

.discovery-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 18px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: rgba(var(--cat-color-rgb), 0.06);
  border: 1px solid rgba(var(--cat-color-rgb), 0.15);
  color: var(--cat-color);
  box-shadow: 0 0 28px rgba(var(--cat-color-rgb), 0.14);
}

.discovery-icon svg {
  width: 24px;
  height: 24px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.discovery-title {
  margin: 0 0 10px;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.1;
  color: #f5f5f5;
}

.discovery-body {
  margin: 0 0 22px;
  text-align: center;
  font-size: 13px;
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.52);
}

.discovery-rewards {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 22px;
}

.discovery-pill {
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 7px 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
}

.discovery-pill::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(120deg, transparent 20%, rgba(255, 255, 255, 0.18) 50%, transparent 80%);
  background-size: 180% 100%;
  animation: discovery-pill-shine 1.5s linear 0.2s infinite;
  pointer-events: none;
}

.discovery-pill--tokens {
  border: 1px solid rgba(34, 197, 94, 0.28);
  background: rgba(34, 197, 94, 0.12);
  color: #4ade80;
}

.discovery-pill--xp {
  border: 1px solid rgba(56, 189, 248, 0.28);
  background: rgba(56, 189, 248, 0.12);
  color: #38bdf8;
}

.discovery-pill-icon {
  font-size: 14px;
  font-weight: 800;
}

.discovery-confirm-btn {
  width: 100%;
  border: none;
  border-radius: 10px;
  padding: 12px 18px;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 150ms ease, filter 150ms ease, box-shadow 150ms ease;
  box-shadow: 0 14px 30px rgba(239, 68, 68, 0.22);
}

.discovery-confirm-btn:hover {
  transform: translateY(-1px);
  filter: brightness(1.05);
  box-shadow: 0 18px 36px rgba(239, 68, 68, 0.3);
}

.discovery-confirm-btn:active {
  transform: translateY(0);
}

.discovery-progress {
  margin-top: 18px;
}

.discovery-progress-track {
  height: 2px;
  overflow: hidden;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
}

.discovery-progress-fill {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #ef4444, #f97316);
  transition: width 240ms ease;
}

.discovery-progress-label {
  display: inline-block;
  margin-top: 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.36);
}

@keyframes discovery-overlay-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes discovery-modal-in {
  from {
    opacity: 0;
    transform: scale(0.94) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes discovery-pill-shine {
  from { background-position: 180% 0; }
  to { background-position: -20% 0; }
}

@media (max-width: 1800px) {
  .discovery-modal {
    padding:
      clamp(24px, 1.56vw, 28px)
      clamp(20px, 1.56vw, 28px)
      clamp(20px, 1.33vw, 24px);
  }

  .discovery-icon {
    width: clamp(48px, 3.11vw, 56px);
    height: clamp(48px, 3.11vw, 56px);
    margin-bottom: clamp(14px, 1vw, 18px);
  }

  .discovery-icon svg {
    width: clamp(21px, 1.33vw, 24px);
    height: clamp(21px, 1.33vw, 24px);
  }

  .discovery-title {
    font-size: clamp(21px, 1.33vw, 24px);
  }
}

@media (max-width: 520px) {
  .discovery-overlay {
    padding: 16px;
  }

  .discovery-modal {
    padding: 24px 20px 20px;
  }

  .discovery-rewards {
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DiscoveryModal/DiscoveryModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb;;uBAEqB;EACrB,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;EAC3C;mFACiF;EACjF;;6CAE2C;EAC3C,iEAAiE;AACnE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,YAAY;EACZ,+FAA+F;EAC/F,8EAA8E;EAE9E,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kDAAkD;EAClD,4CAA4C;EAC5C,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;EAC5C,kDAAkD;EAClD,uBAAuB;EACvB,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oGAAoG;EACpG,0BAA0B;EAC1B,yDAAyD;EACzD,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0EAA0E;EAC1E,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,oDAAoD;EACpD,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,2BAA2B,EAAE;AACpC;;AAEA;EACE;IACE;;;+BAG2B;EAC7B;;EAEA;IACE,gCAAgC;IAChC,iCAAiC;IACjC,qCAAqC;EACvC;;EAEA;IACE,gCAAgC;IAChC,iCAAiC;EACnC;;EAEA;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".discovery-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background:\n    radial-gradient(circle at top, rgba(239, 68, 68, 0.12), transparent 32%),\n    rgba(0, 0, 0, 0.88);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  animation: discovery-overlay-in 0.28s ease;\n}\n\n.discovery-modal {\n  --cat-color: #ef4444;\n  --cat-color-rgb: 239, 68, 68;\n  position: relative;\n  width: min(100%, 420px);\n  padding: 28px 28px 24px;\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background:\n    linear-gradient(180deg, rgba(24, 24, 28, 0.98) 0%, rgba(12, 12, 14, 0.98) 100%);\n  box-shadow:\n    0 28px 90px rgba(0, 0, 0, 0.62),\n    0 0 0 1px rgba(255, 255, 255, 0.03) inset;\n  animation: discovery-modal-in 0.35s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.discovery-modal::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  padding: 1px;\n  background: linear-gradient(180deg, rgba(var(--cat-color-rgb), 0.5), rgba(255, 255, 255, 0.02));\n  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  pointer-events: none;\n}\n\n.discovery-modal--combat {\n  --cat-color: #ef4444;\n  --cat-color-rgb: 239, 68, 68;\n}\n\n.discovery-modal--tool {\n  --cat-color: #2dd4bf;\n  --cat-color-rgb: 45, 212, 191;\n}\n\n.discovery-modal--progression {\n  --cat-color: #f59e0b;\n  --cat-color-rgb: 245, 158, 11;\n}\n\n.discovery-modal--map {\n  --cat-color: #ef4444;\n  --cat-color-rgb: 239, 68, 68;\n}\n\n.discovery-modal--discovery {\n  --cat-color: #818cf8;\n  --cat-color-rgb: 129, 140, 248;\n}\n\n.discovery-topline {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.discovery-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 5px 10px;\n  border-radius: 999px;\n  border: 1px solid rgba(var(--cat-color-rgb), 0.22);\n  background: rgba(var(--cat-color-rgb), 0.08);\n  color: var(--cat-color);\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n}\n\n.discovery-phase {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.34);\n}\n\n.discovery-icon {\n  width: 56px;\n  height: 56px;\n  margin: 0 auto 18px;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  background: rgba(var(--cat-color-rgb), 0.06);\n  border: 1px solid rgba(var(--cat-color-rgb), 0.15);\n  color: var(--cat-color);\n  box-shadow: 0 0 28px rgba(var(--cat-color-rgb), 0.14);\n}\n\n.discovery-icon svg {\n  width: 24px;\n  height: 24px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.discovery-title {\n  margin: 0 0 10px;\n  text-align: center;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.1;\n  color: #f5f5f5;\n}\n\n.discovery-body {\n  margin: 0 0 22px;\n  text-align: center;\n  font-size: 13px;\n  line-height: 1.65;\n  color: rgba(255, 255, 255, 0.52);\n}\n\n.discovery-rewards {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 22px;\n}\n\n.discovery-pill {\n  position: relative;\n  overflow: hidden;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 7px 12px;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.discovery-pill::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(120deg, transparent 20%, rgba(255, 255, 255, 0.18) 50%, transparent 80%);\n  background-size: 180% 100%;\n  animation: discovery-pill-shine 1.5s linear 0.2s infinite;\n  pointer-events: none;\n}\n\n.discovery-pill--tokens {\n  border: 1px solid rgba(34, 197, 94, 0.28);\n  background: rgba(34, 197, 94, 0.12);\n  color: #4ade80;\n}\n\n.discovery-pill--xp {\n  border: 1px solid rgba(56, 189, 248, 0.28);\n  background: rgba(56, 189, 248, 0.12);\n  color: #38bdf8;\n}\n\n.discovery-pill-icon {\n  font-size: 14px;\n  font-weight: 800;\n}\n\n.discovery-confirm-btn {\n  width: 100%;\n  border: none;\n  border-radius: 10px;\n  padding: 12px 18px;\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 150ms ease, filter 150ms ease, box-shadow 150ms ease;\n  box-shadow: 0 14px 30px rgba(239, 68, 68, 0.22);\n}\n\n.discovery-confirm-btn:hover {\n  transform: translateY(-1px);\n  filter: brightness(1.05);\n  box-shadow: 0 18px 36px rgba(239, 68, 68, 0.3);\n}\n\n.discovery-confirm-btn:active {\n  transform: translateY(0);\n}\n\n.discovery-progress {\n  margin-top: 18px;\n}\n\n.discovery-progress-track {\n  height: 2px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.discovery-progress-fill {\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #ef4444, #f97316);\n  transition: width 240ms ease;\n}\n\n.discovery-progress-label {\n  display: inline-block;\n  margin-top: 8px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.36);\n}\n\n@keyframes discovery-overlay-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes discovery-modal-in {\n  from {\n    opacity: 0;\n    transform: scale(0.94) translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n@keyframes discovery-pill-shine {\n  from { background-position: 180% 0; }\n  to { background-position: -20% 0; }\n}\n\n@media (max-width: 1800px) {\n  .discovery-modal {\n    padding:\n      clamp(24px, 1.56vw, 28px)\n      clamp(20px, 1.56vw, 28px)\n      clamp(20px, 1.33vw, 24px);\n  }\n\n  .discovery-icon {\n    width: clamp(48px, 3.11vw, 56px);\n    height: clamp(48px, 3.11vw, 56px);\n    margin-bottom: clamp(14px, 1vw, 18px);\n  }\n\n  .discovery-icon svg {\n    width: clamp(21px, 1.33vw, 24px);\n    height: clamp(21px, 1.33vw, 24px);\n  }\n\n  .discovery-title {\n    font-size: clamp(21px, 1.33vw, 24px);\n  }\n}\n\n@media (max-width: 520px) {\n  .discovery-overlay {\n    padding: 16px;\n  }\n\n  .discovery-modal {\n    padding: 24px 20px 20px;\n  }\n\n  .discovery-rewards {\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
